export default function masterVendorDirective() {
  console.log('app.components.admin.vendorManagementAdmin.masterVendorDirective created');
  return {
    template: require('./master-vendor.directive.html'),
    controller: 'VMAMasterVendorDirectiveController',
    controllerAs: 'vmaMasterVendorVM',
    bindToController: true,
    replace: true,
    scope: {
      masterVendor: '='
    },
  };
}
